import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import ResourcesViewPage from '@/areas/manufacturing-templates/Resources/ResourcesView/ResourcesViewPage';
import { canViewManufacturing } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/next/templates/manufacturing/resources/')({
    staticData: { access: { permissions: canViewManufacturing }, chrome: 'none' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <ResourcesViewPage />;
}
